// Presentation helpers for the deleted-books page (刪除的帳本).
// Books are soft-deleted and kept for a retention window; the API returns
// payments_count and days_left so we only format them here.

// "14 筆帳款" summary line under a deleted book's name.
export const deletedBookMetaText = (book) => {
  const payments = book.payments_count || 0
  if (payments === 0) {
    return '沒有帳款紀錄'
  }

  return `${payments} 筆帳款`
}

// How much of the retention window is left.
export const retentionText = (book) => {
  const days = book.days_left || 0
  if (days === 0) {
    return '保留期限已過'
  }
  if (days === 1) {
    return '剩最後 1 天可以還原'
  }

  return `還有 ${days} 天可以還原`
}
